import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// pdfMake fontlarını kaydet
if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else if (pdfFonts) {
    pdfMake.vfs = pdfFonts;
}

/**
 * Onarım Kapanış Formu PDF (pdfMake ile)
 * Türkçe karakter desteği tam olarak çalışır
 *
 * options.halfPage = true  →  A5 boyutunda (yarım A4) çıktı
 */
class RepairClosingPdfFormPdfMake {
    /**
     * Sayıyı formatlar - negatif değerleri 0 yapar
     */
    formatNumber(value, decimals = 2) {
        if (value === null || value === undefined || isNaN(value)) return '0.00';
        const num = Number(value);
        if (num < 0) return '0.00';
        return num.toFixed(decimals);
    }

    /**
     * Font boyutlarını half-page moduna göre ayarla
     */
    fs(base, half) {
        return half ? Math.max(5, base - 1.5) : base;
    }

    /**
     * PDF'i oluşturur
     * @param {Object} data - PDF verileri
     * @param {Object} translations - Çeviri objeleri
     * @param {Object} options - { halfPage: boolean }
     */
    generate(data, translations = {}, options = {}) {
        const half = !!options.halfPage;
        const reportDate = data.reportDate || new Date().toLocaleDateString('tr-TR');
        const reportTime = data.reportTime || new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
        const reportCode = data.reportCode || data.id || '-';
        const reportReceiver = data.reportReceiver || data.receivingPerson || '-';

        const margins = half ? [15, 15, 15, 15] : [25, 25, 25, 25];
        const sectionGap = half ? 1 : 2;

        const docDefinition = {
            pageSize: half ? 'A5' : 'A4',
            pageMargins: margins,
            content: [
                this.createHeader(translations, reportDate, reportTime, reportCode, reportReceiver, half),
                { text: '', margin: [0, sectionGap] },

                this.createCustomerInfo(data, half),
                { text: '', margin: [0, sectionGap] },

                this.createRepairInfo(data, translations, half),
                { text: '', margin: [0, sectionGap] },

                this.createEstimatedCostTable(data, translations, half),
                { text: '', margin: [0, sectionGap] },

                this.createDeliveryInfo(data, translations, half),
                { text: '', margin: [0, sectionGap] },

                this.createNotes(data, translations, half),
                { text: '', margin: [0, sectionGap] },

                this.createPartsTable(data, translations, half),
                { text: '', margin: [0, 2] },
                this.createWarrantyLegend(translations, half),

                this.createTotals(data, translations, half)
            ],
            defaultStyle: {
                font: 'Roboto'
            }
        };

        return pdfMake.createPdf(docDefinition);
    }

    /**
     * Garanti Tipi Lejant
     */
    createWarrantyLegend(translations, half) {
        const sz = this.fs(6.5, half);
        return {
            margin: [0, half ? 3 : 6, 0, 0],
            table: {
                body: [
                    [
                        { text: [{ text: 'K', bold: true }, { text: ` : ${translations.karsanWarranty || 'Karsan Garantili'}` }], fontSize: sz, color: '#666666', border: [false, false, false, false] },
                        { text: [{ text: 'M', bold: true }, { text: ` : ${translations.customerPays || 'Müşteri Öder'}` }], fontSize: sz, color: '#666666', border: [false, false, false, false], margin: [10, 0, 10, 0] },
                        { text: [{ text: 'S', bold: true }, { text: ` : ${translations.serviceWarranty || 'Servis Garantili'}` }], fontSize: sz, color: '#666666', border: [false, false, false, false] }
                    ]
                ]
            },
            layout: 'noBorders'
        };
    }

    /**
     * Başlık - Logo ve Form Bilgileri
     */
    createHeader(translations, reportDate, reportTime, reportCode, reportReceiver, half) {
        const titleSize = this.fs(12, half);
        const infoSize = this.fs(7, half);

        return {
            columns: [
                {
                    width: 'auto',
                    columns: [
                        {
                            width: half ? 25 : 30,
                            canvas: [
                                { type: 'polyline', points: [{ x: 0, y: 0 }, { x: 15, y: 0 }, { x: 1, y: 15 }], color: '#F05133', closePath: true },
                                { type: 'polyline', points: [{ x: 0, y: 30 }, { x: 15, y: 30 }, { x: 1, y: 15 }], color: '#F05133', closePath: true },
                                { type: 'rect', x: 0, y: 0, w: 1, h: 30, color: '#F05133' },
                                { type: 'polyline', points: [{ x: 30, y: 0 }, { x: 30, y: 30 }, { x: 15, y: 15 }], color: '#F05133', closePath: true }
                            ]
                        },
                        {
                            text: 'KARSAN',
                            fontSize: this.fs(12, half),
                            bold: true,
                            color: '#76777A',
                            margin: [4, 6, 0, 0]
                        }
                    ]
                },
                {
                    stack: [
                        { text: translations.title || 'Onarım Kapanış Formu', fontSize: titleSize, bold: true, color: '#273A81', alignment: 'right' },
                        { text: `${translations.reportDate || 'Rapor Tarihi'} : ${reportDate}`, fontSize: infoSize, color: '#505050', alignment: 'right', margin: [0, 2, 0, 0] },
                        { text: `${translations.reportTime || 'Rapor Saati'} : ${reportTime}`, fontSize: infoSize, color: '#505050', alignment: 'right' },
                        { text: `${translations.reportCode || 'Rapor Kodu'} : ${reportCode}`, fontSize: infoSize, color: '#505050', alignment: 'right' },
                        { text: `${translations.reportReceiver || 'Raporu Alan'} : ${reportReceiver}`, fontSize: infoSize, color: '#505050', alignment: 'right' }
                    ],
                    width: '*'
                }
            ]
        };
    }

    /**
     * Müşteri ve Lokasyon Bilgileri
     */
    createCustomerInfo(data, half) {
        const nameSize = this.fs(9, half);
        const detailSize = this.fs(7, half);
        return {
            stack: [
                { text: data.customerNameSurname || data.adSoyad || ' ', fontSize: nameSize, bold: true, color: '#2C3E50' },
                { text: data.customerAddress || ' ', fontSize: detailSize, margin: [0, 1, 0, 0] },
                { text: `${data.customerCity || ' '}  ${data.customerBranch || data.fullName || ' '}`, fontSize: detailSize }
            ]
        };
    }

    /**
     * Onarım Bilgileri - Kompakt tablo layout
     */
    createRepairInfo(data, translations, half) {
        const repairDate = data.repairDate || data.createdDate
            ? new Date(data.repairDate || data.createdDate).toLocaleDateString('tr-TR')
            : new Date().toLocaleDateString('tr-TR');
        const repairTime = data.repairTime || new Date().toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
        const invoiceDate = data.invoiceDate ? new Date(data.invoiceDate).toLocaleDateString('tr-TR') : '-';

        const lbl = this.fs(6, half);
        const val = this.fs(7, half);

        const cell = (label, value) => ({
            stack: [
                { text: label, fontSize: lbl, color: '#666666' },
                { text: value || '-', fontSize: val, bold: true }
            ],
            margin: [2, 1, 2, 1]
        });

        const thinBorder = {
            hLineWidth: () => 0.4,
            vLineWidth: () => 0.4,
            hLineColor: () => '#DEE2E6',
            vLineColor: () => '#DEE2E6'
        };

        return {
            table: {
                widths: ['20%', '20%', '12%', '25%', '23%'],
                body: [
                    // Satır 1: Onarım No | Tarih | Saat | Plaka | KM
                    [
                        cell(translations.repairNo || 'ONARIM NO', data.repairNo || data.onarimNo || data.id || '-'),
                        cell(translations.repairDate || 'TARİH', repairDate),
                        cell(translations.repairTime || 'SAAT', repairTime),
                        cell(translations.licensePlate || 'PLAKA', data.licensePlate || '-'),
                        cell(translations.km || 'KM', data.kmInformation || '-')
                    ],
                    // Satır 2: Şasi No | Garanti Tipi | Fatura Tarihi | Fatura No | (boş)
                    [
                        { ...cell(translations.chassisNo || 'ŞASİ NO', data.chassisNo || '-'), colSpan: 2 }, {},
                        cell(translations.vehicleType || 'Garanti Tipi', data.vehicleType || data.model || '-'),
                        cell(translations.invoiceDate || 'FATURA TARİHİ', invoiceDate),
                        cell(translations.invoiceNo || 'FATURA NO', data.invoiceNo || '-')
                    ],
                    // Satır 3: Müşteri Beyanı (tam genişlik)
                    [
                        { ...cell(translations.arrivalReason || 'Müşteri Beyanı', data.arrivalReason || data.customerStatement || '-'), colSpan: 5 }, {}, {}, {}, {}
                    ]
                ]
            },
            layout: thinBorder
        };
    }

    /**
     * Tahmini Ücret Tablosu + İskonto Oranları
     */
    createEstimatedCostTable(data, translations, half) {
        const sz = this.fs(7, half);
        const hdrSz = this.fs(7, half);

        const laborPrice = this.formatNumber(data.estimatedLabor || data.totalLaborAcceptedPrice || data.totalLaborPrice);
        const partPrice = this.formatNumber(data.estimatedPart || data.totalItemAcceptedPrice || data.totalItemPrice);
        const otherCostPrice = this.formatNumber(data.estimatedOtherCost || data.totalOtherCostPrice);
        const totalPrice = this.formatNumber(data.estimatedTotal || data.totalDiscountedPrice ||
            ((data.totalLaborAcceptedPrice || data.totalLaborPrice || 0) +
                (data.totalItemAcceptedPrice || data.totalItemPrice || 0) +
                (data.totalOtherCostPrice || 0)));

        // İskonto oranları
        const partsDiscount = data.partsDiscountRate != null ? `%${this.formatNumber(data.partsDiscountRate)}` : '-';
        const laborDiscount = data.laborDiscountRate != null ? `%${this.formatNumber(data.laborDiscountRate)}` : '-';

        const thinBorder = {
            hLineWidth: () => 0.4,
            vLineWidth: () => 0.4,
            hLineColor: () => '#DEE2E6',
            vLineColor: () => '#DEE2E6'
        };

        return {
            table: {
                widths: ['*', '*', '*', '*', '*', '*', '*'],
                body: [
                    [
                        { text: translations.labor || 'İŞÇİLİK', fontSize: hdrSz, bold: true, fillColor: '#F8F9FA', alignment: 'center' },
                        { text: translations.sparePart || 'YEDEK PARÇA', fontSize: hdrSz, bold: true, fillColor: '#F8F9FA', alignment: 'center' },
                        { text: translations.otherCosts || 'DİĞER MALİYET', fontSize: hdrSz, bold: true, fillColor: '#F8F9FA', alignment: 'center' },
                        { text: translations.total || 'TOPLAM', fontSize: hdrSz, bold: true, fillColor: '#F8F9FA', alignment: 'center' },
                        { text: translations.laborDiscountRate || 'İŞÇ. İSK.%', fontSize: hdrSz, bold: true, fillColor: '#FFF3E0', alignment: 'center' },
                        { text: translations.partsDiscountRate || 'PRÇ. İSK.%', fontSize: hdrSz, bold: true, fillColor: '#FFF3E0', alignment: 'center' },
                        { text: translations.approvedBy || 'ONAY VEREN', fontSize: hdrSz, bold: true, fillColor: '#F8F9FA', alignment: 'center' }
                    ],
                    [
                        { text: laborPrice, fontSize: sz, alignment: 'center' },
                        { text: partPrice, fontSize: sz, alignment: 'center' },
                        { text: otherCostPrice, fontSize: sz, alignment: 'center' },
                        { text: totalPrice, fontSize: sz, alignment: 'center', bold: true },
                        { text: laborDiscount, fontSize: sz, alignment: 'center', color: '#E65100' },
                        { text: partsDiscount, fontSize: sz, alignment: 'center', color: '#E65100' },
                        { text: data.approvedBy || '', fontSize: sz, alignment: 'center' }
                    ]
                ]
            },
            layout: thinBorder
        };
    }

    /**
     * Teslim Bilgileri
     */
    createDeliveryInfo(data, translations, half) {
        return {
            columns: [
                this.createField(translations.deliveredBy || 'Teslim Eden', data.deliveredBy || '-', '30%', half),
                this.createField(translations.deliveryPhone || 'Telefon', data.deliveryPhone || '-', '22%', half),
                { width: '3%', text: '' },
                this.createField(translations.willReceive || 'Aracı Teslim Alacak', data.receivedBy || '-', '45%', half)
            ]
        };
    }

    /**
     * Açıklama Bölümleri - Kompakt 2x2 grid
     */
    createNotes(data, translations, half) {
        const lbl = this.fs(6, half);
        const val = this.fs(7, half);

        const noteCell = (label, value) => ({
            stack: [
                { text: label, fontSize: lbl, bold: true, color: '#666666' },
                { text: value || '', fontSize: val, margin: [0, 1, 0, 0] }
            ],
            margin: [2, 1, 2, 1]
        });

        const thinBorder = {
            hLineWidth: () => 0.4,
            vLineWidth: () => 0.4,
            hLineColor: () => '#DEE2E6',
            vLineColor: () => '#DEE2E6'
        };

        return {
            table: {
                widths: ['50%', '50%'],
                body: [
                    [
                        noteCell(translations.customerComplaints || 'Müşteri İtirazları', data.customerComplaints || ''),
                        noteCell(translations.serviceNotes || 'Servis Açıklamaları', data.serviceNote || data.customerStatement || '')
                    ],
                    [
                        noteCell(translations.closingNotes || 'Kapanış Notları', data.closingNotes || data.customerStatement || ''),
                        noteCell(translations.failureSolution || 'Arıza Çözümü', data.failureSolution || '')
                    ]
                ]
            },
            layout: thinBorder
        };
    }

    /**
     * Tip'e göre gösterge harfi
     */
    getWarrantyTypeIndicator(tip) {
        if (!tip) return 'M';
        const tipLower = tip.toLowerCase();
        if (tipLower.includes('karsan') && tipLower.includes('garanti')) return 'K';
        if (tipLower.includes('müşteri') || tipLower.includes('musteri') || tipLower.includes('öder')) return 'M';
        if (tipLower.includes('servis') && tipLower.includes('garanti')) return 'S';
        return 'M';
    }

    /**
     * Tip'e göre fiyat - sadece M için gösterilir
     */
    getPriceByWarrantyType(price, tip) {
        const indicator = this.getWarrantyTypeIndicator(tip);
        return indicator === 'M' ? this.formatNumber(price) : '0.00';
    }

    /**
     * Parça/İşçilik Tablosu - Kompakt
     */
    createPartsTable(data, translations, half) {
        const details = data.details || [];
        const sz = this.fs(6.5, half);
        const hdrSz = this.fs(6.5, half);

        const calculateDiscountPercent = (price, acceptedPrice, quantity, tip) => {
            const indicator = this.getWarrantyTypeIndicator(tip);
            if (indicator === 'K' || indicator === 'S') return '0.00';
            const amount = (price || 0) * (quantity || 1);
            if (amount === 0) return '0.00';
            const discount = ((amount - (acceptedPrice || 0)) / amount) * 100;
            return this.formatNumber(Math.max(0, discount));
        };

        const calculateAmount = (price, quantity, tip) => {
            const indicator = this.getWarrantyTypeIndicator(tip);
            if (indicator === 'K' || indicator === 'S') return '0.00';
            if (!price) return '0.00';
            if (!quantity) return this.formatNumber(price);
            return this.formatNumber(price * quantity);
        };

        const tableBody = details.length > 0
            ? details.map((detail) => {
                const warrantyIndicator = this.getWarrantyTypeIndicator(detail.tip);
                return [
                    { text: warrantyIndicator, fontSize: sz, alignment: 'center', bold: true },
                    { text: detail.type || '-', fontSize: sz, alignment: 'center' },
                    { text: detail.code || '-', fontSize: sz, alignment: 'center' },
                    { text: detail.description || '-', fontSize: sz, alignment: 'left' },
                    { text: detail.quantity ? String(detail.quantity) : detail.laborTime ? String(detail.laborTime) : '-', fontSize: sz, alignment: 'center' },
                    { text: this.getPriceByWarrantyType(detail.price, detail.tip), fontSize: sz, alignment: 'right' },
                    { text: calculateAmount(detail.price, detail.quantity, detail.tip), fontSize: sz, alignment: 'right' },
                    { text: calculateDiscountPercent(detail.price, detail.acceptedPrice, detail.quantity, detail.tip), fontSize: sz, alignment: 'center' },
                    { text: this.getPriceByWarrantyType(detail.acceptedPrice, detail.tip), fontSize: sz, alignment: 'right' }
                ];
            })
            : [[{ text: 'Veri Yok', fontSize: sz, alignment: 'center', colSpan: 9 }, {}, {}, {}, {}, {}, {}, {}, {}]];

        const hdrStyle = (text) => ({ text, fontSize: hdrSz, bold: true, fillColor: '#F8F9FA', alignment: 'center' });

        return {
            table: {
                widths: [18, 28, half ? 50 : 60, '*', half ? 26 : 32, 32, 34, 24, 34],
                body: [
                    [
                        hdrStyle(translations.warrantyType || 'Tip'),
                        hdrStyle(translations.orderNo || 'O.T.'),
                        hdrStyle(translations.partNo || 'Parça/İşç. No'),
                        hdrStyle(translations.description || 'Açıklama'),
                        hdrStyle(translations.quantity || 'Adet'),
                        hdrStyle(translations.unitPrice || 'B.Fiyat'),
                        hdrStyle(translations.amount || 'Tutar'),
                        hdrStyle(translations.discount || 'İnd%'),
                        hdrStyle(translations.netTotal || 'Net T.')
                    ],
                    ...tableBody
                ]
            },
            layout: {
                hLineWidth: () => 0.3,
                vLineWidth: () => 0.3,
                hLineColor: () => '#E9ECEF',
                vLineColor: () => '#E9ECEF',
                paddingTop: () => half ? 1 : 2,
                paddingBottom: () => half ? 1 : 2,
                paddingLeft: () => 2,
                paddingRight: () => 2
            }
        };
    }

    /**
     * Toplam Bilgileri
     */
    createTotals(data, translations, half) {
        const sz = this.fs(7, half);

        let closingTotal = data.totalPrice || 0;
        let discountedTotal = data.totalDiscountedPrice || 0;
        let discountTotal = Math.max(0, closingTotal - discountedTotal);
        const kdvRate = data.isDomestic ? 0.20 : 0;
        let kdvTotal = discountedTotal * kdvRate;
        let invoiceTotal = discountedTotal + kdvTotal;

        if (data.details && data.details.length > 0 && closingTotal === 0) {
            const customerPaidDetails = data.details.filter(d => this.getWarrantyTypeIndicator(d.tip) === 'M');

            closingTotal = customerPaidDetails.reduce((sum, d) => {
                const amount = (d.price || 0) * (d.quantity || d.laborTime || 0);
                return sum + amount;
            }, 0);

            discountedTotal = customerPaidDetails.reduce((sum, d) => sum + (d.acceptedPrice || 0), 0);
            discountTotal = Math.max(0, closingTotal - discountedTotal);
            kdvTotal = discountedTotal * kdvRate;
            invoiceTotal = discountedTotal + kdvTotal;
        }

        const row = (label, value, bold = false) => ({
            text: `${label} : ${this.formatNumber(value)}`,
            fontSize: sz,
            alignment: 'right',
            bold
        });

        return {
            margin: [0, half ? 3 : 5, 0, 0],
            columns: [
                { width: '*', text: '' },
                {
                    width: half ? 130 : 160,
                    stack: [
                        row(translations.closingTotal || 'Kapanış Toplam Tutar', closingTotal),
                        row(translations.discountTotal || 'İndirim Tutarı', discountTotal),
                        row(translations.discountedTotal || 'İndirimli Toplam', discountedTotal),
                        row(translations.kdvTotal || 'K.D.V Tutarı', kdvTotal),
                        row(translations.invoiceTotal || 'Fatura Toplamı', invoiceTotal, true)
                    ]
                }
            ]
        };
    }

    /**
     * Alan kutusu oluşturur
     */
    createField(label, value, width, half) {
        const lbl = this.fs(6, half);
        const val = this.fs(7, half);
        return {
            table: {
                widths: ['*'],
                heights: [half ? 8 : 10],
                body: [
                    [
                        {
                            stack: [
                                { text: label, fontSize: lbl, color: '#666666' },
                                { text: value || '-', fontSize: val, bold: true }
                            ],
                            margin: [2, 1, 2, 1]
                        }
                    ]
                ]
            },
            layout: {
                hLineWidth: () => 0.4,
                vLineWidth: () => 0.4,
                hLineColor: () => '#DEE2E6',
                vLineColor: () => '#DEE2E6'
            },
            width: width
        };
    }

    viewPdf(pdfDoc) {
        pdfDoc.open();
    }

    downloadPdf(pdfDoc, filename = 'onarim-kapanis-formu.pdf') {
        pdfDoc.download(filename);
    }
}

export default RepairClosingPdfFormPdfMake;
